<template>
  <vs-select
    class="w-full mt-3"
    :label="label"
    v-model="selected"
    autocomplete
  >
      <vs-select-item
        :key="index"
        :value="item"
        :text="item.nameId"
        v-for="(item, index) in arrayData"
      />

  </vs-select>
</template>

<script>
import store from '@/store/store'

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: '',
          nameEn: '',
          nameId: ''
        }
      }
    },
    topLevel: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Category'
    }
  },
  data () {
    return { store }
  },
  computed: {
    arrayData: {
      get () {
        if(this.topLevel) {
          return this.store.getters['category/arrayData'].filter((i) => i.topLevel === true)
        } else if (this.parentId) {
          return this.store.getters['category/arrayData'].filter((i) => i.parentId === this.parentId)
        } else {
          return this.store.getters['category/arrayData']
        }
      }
    },
    selected: {
      get () {
        return this.data.nameEn
      },
      set (val) {
        let returnData = {
          id: val.id,
          nameId: val.nameId,
          nameEn: val.nameEn,
          iconUrl: val.iconUrl,
          backgroundColor: val.backgroundColor || ''
        }

        if(val.parentId) returnData.parentId = val.parentId

        this.$emit('change', returnData)
      }
    }
  }
}
</script>
